import { useEffect } from "react";
import { useLanguage } from "../LanguageContext";
import React, { useState } from "react";
import { Card, Accordion, Table } from "react-bootstrap";
import "../styles/equipmentPage.css";
// Sample data parsed from the given table structure
const equipmentData = [
    { Kategorie: "Amps", Stk: "", Hersteller: "Vox", Name: "AC15", Größe: "" },
    { Kategorie: "Amps", Stk: "", Hersteller: "Fender", Name: "Custom Vibrolux Reverb", Größe: "" },
    { Kategorie: "Amps", Stk: "", Hersteller: "Tech 21", Name: "SansAmp RBI", Größe: "" },
    { Kategorie: "Amps", Stk: "", Hersteller: "Kemper", Name: "Profiler Rack", Größe: "" },
    { Kategorie: "Amps", Stk: "", Hersteller: "Marshall", Name: "JCM 2000", Größe: "" },
    { Kategorie: "Cymbals", Stk: "", Hersteller: "Meinl", Name: "Pure Alloy Custom Medium Thin Hihat", Größe: "15\"" },
    { Kategorie: "Cymbals", Stk: "", Hersteller: "Meinl", Name: "Extra Thin Hammered Crash", Größe: "20\"" },
    { Kategorie: "Cymbals", Stk: "", Hersteller: "Meinl", Name: "Extra Dry Medium Hihat", Größe: "14\"" },
    { Kategorie: "Cymbals", Stk: "", Hersteller: "Meinl", Name: "Extra Dry Thin Crash", Größe: "18\"" },
    { Kategorie: "Cymbals", Stk: "", Hersteller: "Meinl", Name: "Vintage Crash", Größe: "18\"" },
    { Kategorie: "Cymbals", Stk: "", Hersteller: "Meinl", Name: "Transition Ride", Größe: "21\"" },
    { Kategorie: "Cymbals", Stk: "1", Hersteller: "Stagg", Name: "Sensa Medium Splash", Größe: "12\"" },
    { Kategorie: "Cymbals", Stk: "1", Hersteller: "Anatolian", Name: "Ultimate Splash", Größe: "10\"" },
    { Kategorie: "Cymbals", Stk: "1", Hersteller: "Stagg", Name: "Sensa Medium Splash", Größe: "8\"" },
    { Kategorie: "Cymbals", Stk: "1", Hersteller: "Zildjian", Name: "A New Beat HiHat", Größe: "14\"" },
    { Kategorie: "Cymbals", Stk: "1", Hersteller: "Zildjian", Name: "A Medium Thin Crash", Größe: "18\"" },
    { Kategorie: "Cymbals", Stk: "1", Hersteller: "Zildjian", Name: "A Medium Thin Crash", Größe: "16\"" },
    { Kategorie: "Cymbals", Stk: "1", Hersteller: "Zildjian", Name: "A Medium Ride", Größe: "20\"" },
    { Kategorie: "Drums", Stk: "", Hersteller: "Sonor", Name: "SQ1 Drum Kit", Größe: "22\"/12\"/16\"" },
    { Kategorie: "Drums", Stk: "", Hersteller: "Ludwig", Name: "1967 Drum Kit", Größe: "20\"/13\"/16\"" },
    { Kategorie: "Drums", Stk: "", Hersteller: "Tama", Name: "Superstar Drum Kit", Größe: "22\"/10\"/12\"/14\"" },
    { Kategorie: "Drums", Stk: "", Hersteller: "Sonor", Name: "SQ1 Snare", Größe: "14\"x6.5\"" },
    { Kategorie: "Drums", Stk: "", Hersteller: "Sonor", Name: "Kompressor Alu Snare", Größe: "14\"x6.5\"" },
    { Kategorie: "Drums", Stk: "", Hersteller: "Ludwig", Name: "Supraphonic Snare", Größe: "14\"x6.5\"" },
    { Kategorie: "Drums", Stk: "", Hersteller: "Gretsch", Name: "Hammered Brass Snare", Größe: "14\"x6.5\"" },
    { Kategorie: "Drums", Stk: "", Hersteller: "Pearl", Name: "Chad Smith Signature Snare", Größe: "14\"x5\"" },
    { Kategorie: "Guitars", Stk: "", Hersteller: "Musicman", Name: "James Valentine Signature", Größe: "" },
    { Kategorie: "Guitars", Stk: "", Hersteller: "Epiphone", Name: "Dave Grohl Signature", Größe: "" },
    { Kategorie: "Guitars", Stk: "", Hersteller: "Warmoth", Name: "Telecaster", Größe: "" },
    { Kategorie: "Guitars", Stk: "", Hersteller: "Fender", Name: "Precision Bass", Größe: "" },
    { Kategorie: "Guitars", Stk: "", Hersteller: "Sandberg", Name: "Electra TT 4", Größe: "" },
    { Kategorie: "Guitars", Stk: "", Hersteller: "Ibanez", Name: "AVD15MPL-OPS Acoustic Guitar", Größe: "" },
    { Kategorie: "Microphones", Stk: "1", Hersteller: "Neumann", Name: "U87", Größe: "" },
    { Kategorie: "Microphones", Stk: "1", Hersteller: "Neumann", Name: "TLM 103", Größe: "" },
    { Kategorie: "Microphones", Stk: "1", Hersteller: "Telefunken", Name: "TF 51", Größe: "" },
    { Kategorie: "Microphones", Stk: "4", Hersteller: "AKG", Name: "C 414 EB", Größe: "" },
    { Kategorie: "Microphones", Stk: "2", Hersteller: "Sennheiser", Name: "MD421-2", Größe: "" },
    { Kategorie: "Microphones", Stk: "3", Hersteller: "Shure", Name: "SM 57", Größe: "" },
    { Kategorie: "Microphones", Stk: "2", Hersteller: "Shure", Name: "SM 58", Größe: "" },
    { Kategorie: "Microphones", Stk: "1", Hersteller: "Telefunken", Name: "M80-SH", Größe: "" },
    { Kategorie: "Microphones", Stk: "1", Hersteller: "SE Electronics", Name: "SE 8", Größe: "" },
    { Kategorie: "Microphones", Stk: "1", Hersteller: "SE Electronics", Name: "VR1", Größe: "" },
    { Kategorie: "Microphones", Stk: "1", Hersteller: "AKG", Name: "C 3000 B", Größe: "" },
    { Kategorie: "Microphones", Stk: "1", Hersteller: "Shure", Name: "SM 7B", Größe: "" },
    { Kategorie: "Microphones", Stk: "1", Hersteller: "AKG", Name: "D12", Größe: "" },
    { Kategorie: "Microphones", Stk: "2", Hersteller: "Audix", Name: "D6", Größe: "" },
    { Kategorie: "Microphones", Stk: "1", Hersteller: "Warm Audio", Name: "WA-19N", Größe: "" },
    { Kategorie: "Recording", Stk: "1", Hersteller: "Universal Audio", Name: "Apollo X4", Größe: "" },
    { Kategorie: "Recording", Stk: "1", Hersteller: "Universal Audio", Name: "Apollo X16", Größe: "" },
    { Kategorie: "Recording", Stk: "1", Hersteller: "Universal Audio", Name: "Apollo X8p", Größe: "" },
    { Kategorie: "Preamps", Stk: "2", Hersteller: "Neve", Name: "1176LB Preamp", Größe: "" },
    { Kategorie: "Preamps", Stk: "1", Hersteller: "Neve", Name: "88RLB Preamp", Größe: "" },
    { Kategorie: "Preamps", Stk: "2", Hersteller: "Bloofeld Audio", Name: "BlooPre 2", Größe: "" },
    { Kategorie: "Preamps", Stk: "2", Hersteller: "SSL", Name: "SiX CH Channel Strip", Größe: "" },
    { Kategorie: "Preamps", Stk: "1", Hersteller: "Chandler Limited", Name: "TG2 Preamp", Größe: "" },
    { Kategorie: "Preamps", Stk: "1", Hersteller: "CAPI", Name: "VP28 DBL2 Preamp", Größe: "" },
    { Kategorie: "Preamps", Stk: "1", Hersteller: "Black Lion Audio", Name: "Auteur MKII Mic Preamp", Größe: "" },
    { Kategorie: "Preamps", Stk: "1", Hersteller: "Warm Audio", Name: "WA273-EQ", Größe: "" },
    { Kategorie: "Preamps", Stk: "1", Hersteller: "Warm Audio", Name: "WA-412", Größe: "" },
    { Kategorie: "Outboard", Stk: "1", Hersteller: "Audio-Scape", Name: "EQP1-A", Größe: "" },
    { Kategorie: "Outboard", Stk: "1", Hersteller: "Audio-Scape", Name: "LA-2A", Größe: "" },
    { Kategorie: "Outboard", Stk: "1", Hersteller: "Audio-Scape", Name: "1176 REV-A", Größe: "" },
    { Kategorie: "Monitoring", Stk: "2", Hersteller: "Adam Audio", Name: "A8H", Größe: "" },
    { Kategorie: "Monitoring", Stk: "2", Hersteller: "Samson", Name: "Sphone Headphone Mixer/Amp", Größe: "" },
    { Kategorie: "Monitoring", Stk: "1", Hersteller: "Behringer", Name: "Powerplay 16", Größe: "" }
    ]

const groupByCategory = (data) => {
    return data.reduce((acc, item) => {
        if (!acc[item.Kategorie]) {
            acc[item.Kategorie] = [];
        }
        acc[item.Kategorie].push(item);
        return acc;
    }, {});
};

export const scrollToEquipment = () => {
    const equipmentSection = document.getElementById("equipment");
    if (equipmentSection) {
        equipmentSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};

const Equipment = () => {
    const { translations } = useLanguage();
    const [key, setKey] = useState("about");
    const groupedData = groupByCategory(equipmentData);

    useEffect(() => {
        if (window.location.hash === "#equipment") {
            setTimeout(() => {
                scrollToEquipment();
            }, 300);
        }
    }, []);

    return (
        <Card className="section-card" id="equipment">
            <Card.Body>
                <Card.Title>
                    <h1>{translations.equipment.title}</h1>
                </Card.Title>
                <Card.Text className="equipment-accordion-container">
                    <Accordion defaultActiveKey="0" className="equipment-accordion">
                        {Object.keys(groupedData).map((category, index) => (
                            <Accordion.Item
                                eventKey={index.toString()}
                                key={index}
                                onClick={scrollToEquipment} // Always scroll to equipment when clicking
                            >
                                <Accordion.Header>{category}</Accordion.Header>
                                <Accordion.Body>
                                    <Table striped bordered hover variant="dark">
                                        <thead>
                                        <tr>
                                            <th>Stk</th>
                                            <th>Hersteller</th>
                                            <th>Name</th>
                                            <th>Größe, etc.</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {groupedData[category].map((item, i) => (
                                            <tr key={i}>
                                                <td>{item.Stk}</td>
                                                <td>{item.Hersteller}</td>
                                                <td>{item.Name}</td>
                                                <td>{item.Größe}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </Card.Text>
            </Card.Body>
        </Card>
    );
};

export default Equipment;